module.exports = __webpack_public_path__ + "img/note-upgrade.1f8c15cf.svg";